import { useCallback } from "react";

import { getWorklogHistory } from "../../../../services/apiWorklog";
import { downloadCsvFile } from "../../utils/myTaskUtils";

export function useWorklogCsvDownload({
  users,
  boardIds,
  dateRange,
  epicSearch,
  byTask = false,
}) {
  const downloadCsv = useCallback(() => {
    getWorklogHistory(
      users,
      boardIds,
      dateRange,
      epicSearch,
      true,
      byTask
    )
      .then((response) => {
        downloadCsvFile(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [users, boardIds, dateRange, epicSearch, byTask]);

  return { downloadCsv };
}
